import { queryApi } from 'lib/api';
import { Response } from 'lib/api/type';
import { B2BSignParam, B2BSignResponse } from './type';

export const callB2BsignApi = (data: B2BSignParam): Promise<B2BSignResponse> =>
  queryApi('/channel/account/sign', data);

export const callAccountLogout = (): Promise<Response> =>
  queryApi('/mint/account/logout', {});
